// src/services/approvalsApi.js
import { client } from "./axiosClient";

/* ───────── funções já usadas pelo ApprovalsSection ───────── */
/**
 * Consulta o status de aprovação de UMA iniciativa.
 * @param {string} initiativeId
 * @returns {Promise<{success:boolean, instances:Array}>}
 */
export function getStatus(initiativeId) {
  return client
    .post("/api/approvals/status/", { initiative_id: initiativeId })
    .then((r) => r.data);
}

/**
 * Alias para enviar uma ação de aprovação (mantido p/ compatibilidade).
 * Internamente só faz o proxy para `act`.
 * @param {string} actionId
 * @param {"APP"|"REJ"|"REV"} result
 * @param {string} comment
 */
export function sendAction(actionId, result, comment = "") {
  return act({ actionId, result, comment });
}

/* ───────── NOVOS ENDPOINTS ───────── */
/** Caixa de entrada do aprovador (ações pendentes) */
function inbox() {
  return client.post("/api/approvals/inbox/", {}).then((r) => r.data);
}

/** Executa ação do aprovador */
function act({ actionId, result, comment = "" }) {
  return client.post("/api/approvals/action/", {
    action_id: actionId,
    result,
    comment,
  });
}

/** Flows e instâncias das iniciativas onde sou owner / PMO */
function myInitiatives() {
  return client.post("/api/approvals/my-initiatives/", {}).then((r) => r.data);
}
function myHistory() {
  return client.post("/api/approvals/my-history/", {}).then((r) => r.data);
}

/* =================================================================== */
/* ================== NOVAS FUNÇÕES PARA DATA APPROVALS ================ */
/* =================================================================== */

/**
 * Busca a caixa de entrada para aprovações de DADOS pendentes.
 * @returns {Promise<{success: boolean, pending_changes: Array}>}
 */
function dataInbox() {
  return client.post("/api/approvals/data-inbox/", {}).then((r) => r.data);
}

/**
 * Submete uma ação de aprovação ou rejeição para uma mudança de DADOS pendente.
 * @param {object} payload - The action payload.
 * @param {number} payload.pending_change_id - The ID of the pending change.
 * @param {'approve' | 'reject'} payload.action - The action to perform.
 * @param {string} [payload.comment] - An optional comment for rejection.
 * @returns {Promise<{success: boolean}>}
 */

function dataAction({ pending_change_id, action, comment = "" }) {
  return client
    .post("/api/approvals/data-action/", {
      pending_change_id,
      action,
      comment,
    })
    .then((r) => r.data); // Retornamos .data para consistência
}

/* ───────── export agrupado (opcional) ───────── */
export const approvalsApi = {
  getStatus, // já usado pela ApprovalsSection
  sendAction, // alias antigo
  inbox,
  act,
  myInitiatives,
  myHistory,
  dataInbox,
  dataAction,
};

export default approvalsApi; // caso prefira import default
